import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'accruals-bulk-update',
    templateUrl: 'accruals.bulk.update.component.html',
    standalone: false,
})
export class AccrualsBulkUpdateComponent implements OnInit {
    @Input() bulkUpdateCanceled: boolean = false;
    @Input() bulkUpdateCurrent: { index: number; entry: Core.AccrualsGridEntryModel };
    @Input() selectionsLength: number;
    @Input() summarizeBy: Core.AccrualsGridSummarizeByEnum;
    @Input() bulkUpdateTotals: { rowsChanged: number; billsChanged: number };
    @Output() endBulkUpdate: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    get isBulkUpdateDone() {
        return this.bulkUpdateCurrent && this.bulkUpdateCurrent.index >= this.selectionsLength;
    }

    ngOnInit() {}

    getCurrentBulkUpdateIdentity(): string {
        let identity: string = '';

        if (this.bulkUpdateCurrent) {
            identity = `[${this.bulkUpdateCurrent.index} of ${this.selectionsLength}]     `;

            switch (this.summarizeBy) {
                case Core.AccrualsGridSummarizeByEnum.State:
                    identity += `State: ${this.bulkUpdateCurrent.entry.stateName}`;
                    break;
                case Core.AccrualsGridSummarizeByEnum.Company:
                    identity += `Company: ${this.bulkUpdateCurrent.entry.companyName}  (${this.bulkUpdateCurrent.entry.companyCode})`;
                    break;
                case Core.AccrualsGridSummarizeByEnum.Site:
                    identity += `Site Name: ${this.bulkUpdateCurrent.entry.siteName}`;
                    break;
                case Core.AccrualsGridSummarizeByEnum.Parcel:
                    identity += `Site Name: ${this.bulkUpdateCurrent.entry.siteName}`;
                    identity += `    Parcel: ${this.bulkUpdateCurrent.entry.parcelAcctNum}`;
                    break;
                case Core.AccrualsGridSummarizeByEnum.Bills:
                    identity += `Site Name: ${this.bulkUpdateCurrent.entry.siteName}`;
                    identity += `    Parcel: ${this.bulkUpdateCurrent.entry.parcelAcctNum}`;
                    identity += `    Collector: ${this.bulkUpdateCurrent.entry.collectorAbbr}`;
                    break;
                case Core.AccrualsGridSummarizeByEnum.EconomicUnit:
                    switch (this.bulkUpdateCurrent.entry.economicUnitTypeId) {
                        case Core.AccrualEconomicUnitTypeEnum.SiteNumber:
                            identity += `Site Number: ${this.bulkUpdateCurrent.entry.siteNumber}`;
                            break;
                        case Core.AccrualEconomicUnitTypeEnum.SubsidiaryCompany:
                            identity += `Company: ${this.bulkUpdateCurrent.entry.companyName}`;
                            break;
                        case Core.AccrualEconomicUnitTypeEnum.SiteCode:
                            identity += `Site Code: ${this.bulkUpdateCurrent.entry.siteCode}`;
                            break;
                        case Core.AccrualEconomicUnitTypeEnum.Parcel:
                            identity += `Site Name: ${this.bulkUpdateCurrent.entry.siteName}`;
                            identity += `    Parcel: ${this.bulkUpdateCurrent.entry.parcelAcctNum}`;
                            break;
                        case Core.AccrualEconomicUnitTypeEnum.Bill:
                            identity += `Site Name: ${this.bulkUpdateCurrent.entry.siteName}`;
                            identity += `    Parcel: ${this.bulkUpdateCurrent.entry.parcelAcctNum}`;
                            identity += `    Collector: ${this.bulkUpdateCurrent.entry.collectorAbbr}`;
                            break;
                    }
                    break;
            }
        }
        return identity;
    }
}
